import { mascotWithItemsStyles } from "./MascotWithItemsStyles";

interface MascotWithItemsProps {
  showCrown?: boolean;
  hidden?: boolean;
  mascotState?: string;
  inventoryItemDTOList?: any[];
  onClick?: () => void;
  onLoad?: () => void;
}

const MascotWithItems = (props: MascotWithItemsProps) => {
  const {
    showCrown = false,
    hidden = false,
    mascotState = "CLOSED",
    inventoryItemDTOList = [],
    onClick = () => {},
    onLoad = () => {},
  } = props;

  const shirtInventoryItemDTO = inventoryItemDTOList.find(
    (inventoryItemDTO: any) => inventoryItemDTO.marketItemDTO.type === "SHIRT",
  );
  const eyeInventoryItemDTO = inventoryItemDTOList.find(
    (inventoryItemDTO: any) => inventoryItemDTO.marketItemDTO.type === "EYE",
  );
  const jacketInventoryItemDTO = inventoryItemDTOList.find(
    (inventoryItemDTO: any) => inventoryItemDTO.marketItemDTO.type === "JACKET",
  );
  const headInventoryItemDTO = inventoryItemDTOList.find(
    (inventoryItemDTO: any) => inventoryItemDTO.marketItemDTO.type === "HEAD",
  );
  const neckInventoryItemDTO = inventoryItemDTOList.find(
    (inventoryItemDTO: any) => inventoryItemDTO.marketItemDTO.type === "NECK",
  );
  const glassesInventoryItemDTO = inventoryItemDTOList.find(
    (inventoryItemDTO: any) =>
      inventoryItemDTO.marketItemDTO.type === "GLASSES",
  );

  return (
    <div className="qaz-root" style={{ lineHeight: 1 }}>
      <style>{mascotWithItemsStyles}</style>
      {shirtInventoryItemDTO ? (
        <div className="qaz-item qaz-shirt">
          <img
            src={`/market/shirt/${shirtInventoryItemDTO.marketItemDTO.name}.webp`}
            alt="market-item"
            className="qaz-fill"
            style={{ objectFit: "contain" }}
          />
        </div>
      ) : null}
      {eyeInventoryItemDTO ? (
        <div className="qaz-item qaz-eye">
          <img
            src={`/market/eye/${eyeInventoryItemDTO.marketItemDTO.name}.webp`}
            alt="market-item"
            className="qaz-fill"
            style={{ objectFit: "contain" }}
          />
        </div>
      ) : null}
      {glassesInventoryItemDTO ? (
        <div className="qaz-item qaz-glasses">
          <img
            src={`/market/glasses/${glassesInventoryItemDTO.marketItemDTO.name}.webp`}
            alt="market-item"
            className="qaz-fill"
            style={{ objectFit: "contain" }}
          />
        </div>
      ) : null}
      {jacketInventoryItemDTO ? (
        <div className="qaz-item qaz-jacket">
          <img
            src={`/market/jacket/${jacketInventoryItemDTO.marketItemDTO.name}.webp`}
            alt="market-item"
            className="qaz-fill"
            style={{ objectFit: "contain" }}
          />
        </div>
      ) : null}
      {showCrown ? null : headInventoryItemDTO ? (
        headInventoryItemDTO.marketItemDTO.groupKey === "pom-hat" ? (
          <div className="qaz-item qaz-head-pompom">
            <img
              src={`/market/head/${headInventoryItemDTO.marketItemDTO.name}.webp`}
              alt="market-item"
              className="qaz-fill"
              style={{ objectFit: "contain" }}
            />
          </div>
        ) : (
          <div className="qaz-item qaz-head-plain">
            <img
              src={`/market/head/${headInventoryItemDTO.marketItemDTO.name}.webp`}
              alt="market-item"
              className="qaz-fill"
              style={{ objectFit: "contain" }}
            />
          </div>
        )
      ) : null}
      {neckInventoryItemDTO ? (
        neckInventoryItemDTO.marketItemDTO.name.startsWith("tie") ? (
          <div className="qaz-item qaz-neck-tie">
            <img
              src={`/market/neck/${neckInventoryItemDTO.marketItemDTO.name}.webp`}
              alt="market-item"
              className="qaz-fill"
              style={{ objectFit: "contain" }}
            />
          </div>
        ) : (
          <div className="qaz-item qaz-neck-other">
            <img
              src={`/market/neck/${neckInventoryItemDTO.marketItemDTO.name}.webp`}
              alt="market-item"
              className="qaz-fill"
              style={{ objectFit: "contain" }}
            />
          </div>
        )
      ) : null}

      <img
        src={`/mascots/${mascotState.toLowerCase()}.webp`}
        alt="mascot"
        onClick={onClick}
        className="qaz-fill"
        hidden={hidden}
        onLoad={onLoad}
        style={{ objectFit: "contain", cursor: "pointer" }}
      />
    </div>
  );
};

export default MascotWithItems;
